import "./sprinkles.css.ts.vanilla.css-mistica.js";
import "./password-field.css.ts.vanilla.css-mistica.js";
var f = "ptqylz1 _1y2v1nf68 _1y2v1nf7h _1y2v1nf8q _1y2v1nf9z _1y2v1nfdo _1y2v1nf5y";
export { f as shadow };
